import config from '../config/config';
import api from '../services/api';
import { SourcesIds } from '../constants/SOURCES';

export default {
  root: () => {
    const {
      settings: { lang = 'ru', eventHallLayoutId },
    } = window.Widget;
    const query = lang !== 'ru' ? `?lang=${lang}` : '';

    return api.get(
      `${config.ticketsApiRoute}/public/v1/hall-layouts/${eventHallLayoutId}/coordinates${query}`,
    );
  },
  datesPrices: async () => {
    const { settings } = window.Widget;
    const currency_code = settings.currency || 'RUB';

    if (settings.eventSourceId) {
      const response = await api.get(`${config.aggregatedApiRoute}/public/v2/dates_prices`, {
        params: {
          event_source_id: settings.eventSourceId,
          currency_code,
          source_id: settings.isLanding ? SourcesIds.landings : SourcesIds.marketplace,
        },
      });

      return response.data.filter((price) => price.min_price);
    }

    return [];
  },
  tickets: () => {
    const { settings, metaController } = window.Widget;
    const event = settings.isLanding
      ? metaController.selectedEvent || settings.selectedEvent
      : settings.eventDateId || settings.selectedEvent;
    const lang = settings.lang || 'ru';
    const currency = settings.currency || 'RUB';

    return api.get(`${config.aggregatedApiRoute}/public/v2/tickets`, {
      params: {
        currency_code: currency,
        lang,
        event_source_id: settings.eventSourceId,
        event_date_id: event || settings.eventDateId,
        source_id: settings.isLanding ? SourcesIds.landings : SourcesIds.marketplace,
      },
    });
  },
  getStandTickets: () => {
    const { settings, metaController } = window.Widget;
    const event = settings.isLanding
      ? metaController.selectedEvent || settings.selectedEvent
      : settings.eventDateId || settings.selectedEvent;
    const currency = settings.currency || 'RUB';

    return api.get(`${config.ticketsApiRoute}/public/v2/standing_tickets`, {
      params: {
        event_source_id: settings.eventSourceId,
        event_date_id: event || settings.eventDateId,
        currency_code: currency,
        source_id: settings.isLanding ? SourcesIds.landings : SourcesIds.marketplace,
      },
    });
  },
};
